export default function Gallery() {
  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Nos réalisations à Lingolsheim
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <div className="rounded-2xl overflow-hidden bg-white border border-rose-100 aspect-[4/3]">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/c450ec3e7af2cc1bbbd1474556446aa2.jpeg"
              alt="Réparation de fenêtre PVC à Lingolsheim, Bas-Rhin"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="rounded-2xl overflow-hidden bg-white border border-rose-100 aspect-[4/3]">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/be6c1f97d5ea7df8bcbfbe3be74c7a73.jpeg"
              alt="Réglage crémone fenêtre aluminium à Lingolsheim"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="rounded-2xl overflow-hidden bg-white border border-rose-100 aspect-[4/3]">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/77a12784605cc455b206bd0338fab5f1.jpeg"
              alt="Maison avec fenêtre réparée à Lingolsheim, Bas-Rhin"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}